<template>
  <fieldset class="account__form-section">
    <legend class="account__form-section-title">Account Status</legend>
    <div class="input-group__wrap">
      <div class="input-group__field-wrap">
        <p class="input-group__label layout--margin-bottom-xs">
          Status
        </p>
        <p>{{ accountStatus }}</p>
      </div>
      <div class="input-group__field-wrap">
        <p class="input-group__label layout--margin-bottom-xs">Current Plan</p>
        <p>
          {{ mySubscription.label }}
        </p>
      </div>
    </div>
    <div class="input-group__wrap">
      <div class="input-group__field-wrap">
        <p class="input-group__label layout--margin-bottom-xs">
          Account Owner
        </p>
        <p>{{ user.firstName }} {{ user.lastName }}</p>
      </div>
    </div>
    <button
      type="button"
      class="button layout--margin-top-xs"
      v-on:click="showModal"
    >
      Close Account
    </button>
  </fieldset>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import CloseAccountModal from "./CloseAccountModal";

export default {
  name: "AccountStatus",
  mounted: function() {
    if (this.subscriptionOptions.length === 0) {
      this.getSubscriptionOptions();
    }
  },
  methods: {
    ...mapActions("account", ["getSubscriptionOptions"]),
    showModal() {
      this.$modal.show(CloseAccountModal);
    },
    hideModal(event) {
      this.$modal.hide(CloseAccountModal);
    },
  },
  computed: {
    ...mapGetters("account", [
      "user",
      "account",
      "subscription",
      "subscriptionOptions",
    ]),
    accountStatus: function() {
      if (!this.account.active) return 'Inactive';
      if (this.account.suspended) return 'Suspended';
      return 'Active';
    },
    mySubscription: function() {
      if (this.subscription && this.subscriptionOptions.length > 0) {
        return this.subscriptionOptions.find(
          s => s.subscriptionType === this.subscription.subscriptionType
        );
      }
      return { label: "" };
    },
  },
};
</script>

<style></style>
